import { render, staticRenderFns } from "./regulatory-bundle-table.vue?vue&type=template&id=27977aee"
import script from "./regulatory-bundle-table.vue?vue&type=script&lang=js"
export * from "./regulatory-bundle-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports